<template>
    <div class="loading">
        <div class="loading__holder">
            <i class="uk-icon-spinner uk-icon-spin"></i>
            <span>Загрузка</span>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
.loading
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    &__holder
        display: flex
        flex-direction: column
        gap: 5px
        align-items: center
        justify-content: center
        span, i
            color: #999
        i
            font-size: 30px
        span
            font-size: 11px

            
</style>